import { AxiosSingleton } from '@/common/di';
import {
  GetCentresModel,
  GetClosuresModel,
  GetEventsModel,
  GetIncidentsModel,
  GetWarningByIdModel,
  GetWarningsModel,
  HazardsDataSource,
} from '@/features/hazards';
import { Axios } from 'axios';
import { container } from 'tsyringe';
import { GetTotalFireBansModel } from '../models/hazards/get-fireban-model';

export class RemoteHazardsDataSource implements HazardsDataSource {
  api: Axios;

  constructor() {
    this.api = container.resolve(AxiosSingleton).eca;
  }

  async getClosures(language?: string): Promise<GetClosuresModel[]> {
    const searchParams = new URLSearchParams();

    if (language) {
      searchParams.append('language', language);
    }

    const res = await this.api.get(`/closures?${searchParams.toString()}`);
    return res.data.closures;
  }

  async getCentres(language?: string): Promise<GetCentresModel[]> {
    const searchParams = new URLSearchParams();

    if (language) {
      searchParams.append('language', language);
    }

    const res = await this.api.get(`/centres?${searchParams.toString()}`);
    return res.data.centres;
  }

  async getWarnings(language?: string): Promise<GetWarningsModel[]> {
    const searchParams = new URLSearchParams();
    if (language) {
      searchParams.append('language', language);
    }

    const res = await this.api.get(`/warnings?${searchParams.toString()}`);
    return res.data.warnings;
  }

  async getIncidents(language?: string): Promise<GetIncidentsModel[]> {
    const searchParams = new URLSearchParams();
    if (language) {
      searchParams.append('language', language);
    }

    const res = await this.api.get(`/incidents?${searchParams.toString()}`);
    return res.data.incidents;
  }

  async getEvents(language?: string): Promise<GetEventsModel[]> {
    const searchParams = new URLSearchParams();
    if (language) {
      searchParams.append('language', language);
    }

    const res = await this.api.get(`/events?${searchParams.toString()}`);
    return res.data.events;
  }

  async getTotalFireBans(): Promise<GetTotalFireBansModel[]> {
    const res = await this.api.get('/total-fire-bans');
    return res.data.totalFireBans;
  }

  async getWarningById(warningId: string): Promise<GetWarningByIdModel> {
    const res = await this.api.get(`/warnings/${warningId}`);
    return res.data;
  }
}
